import { render, staticRenderFns } from "./RepoViewer.vue?vue&type=template&id=61346b4c&scoped=true&"
import script from "./RepoViewer.vue?vue&type=script&lang=js&"
export * from "./RepoViewer.vue?vue&type=script&lang=js&"
import style0 from "./RepoViewer.vue?vue&type=style&index=0&id=61346b4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61346b4c",
  null
  
)

export default component.exports